export default {"src":"/_next/static/media/brand-selected-level.5c0bfa13.svg","height":12,"width":11,"blurWidth":0,"blurHeight":0};